import React from 'react'; // eslint-disable-line no-unused-vars
import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import user from 'shared/src/stores/UserStore';
import userOrganization from 'shared/src/stores/UserOrganizationStore';
import dialog from 'shared/src/components/dialog/DialogStore';
import theme from 'shared/src/stores/ThemeStore';
import fence from 'shared/src/stores/FenceStore';
import portal, { portalStoreInit } from 'shared/src/stores/PortalStore';
import player from './portal/recordings/PlayerStore';
import navigation from 'shared/src/stores/NavigationStore';

portalStoreInit('app');

// /////////////////////////////////////////////////////////////////////////////////////////////////
// Automatically adds the thunk middleware and the Redux DevTools extension
const Store = configureStore({
  // Automatically calls `combineReducers`
  reducer: {
    user,
    userOrganization,
    dialog,
    theme,
    portal,
    fence,
    player,
    navigation,
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware();
      const logger = createLogger({
        collapsed: true,
        duration: true,
        timestamp: true,
        logErrors: true,
      });
    middleware.push(logger);
    return middleware;
  },
  // Turn off devtools in prod, or pass options in dev
  devTools: process.env.NODE_ENV === 'production' ? false : true,
});

export default Store;
